// extracted by mini-css-extract-plugin
export default {"melodyVideo":"xI-z","isFullWidth":"yI-z","landingPageVideo":"zI-z","play":"AI-z","iframeVideo":"BI-z","playHidden":"CI-z","fullwidth":"DI-z"};